(function () {
    'use strict';

    angular.module('app.markettemplates', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();